import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CentralClientePacoteListarComponent } from './central-cliente-pacote-listar.component';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    {path:'', component: CentralClientePacoteListarComponent}
  ])],
  exports: [RouterModule]
})
export class CentralClientePacoteListarRoutingModule { }
